import React, { useState } from 'react';
import { Briefcase, CheckSquare, Clock, Award, Star, UserCheck } from 'lucide-react';

export const VocationalLivingModule: React.FC = () => {
  const [tasks, setTasks] = useState([
    { id: 1, title: 'Safe Appliance Operation (Microwave & Kettle)', category: 'Daily Living', status: 'Completed', score: 95 },
    { id: 2, title: 'Supermarket Checkout & Cash Handling', category: 'Vocational', status: 'In Progress', score: 80 },
    { id: 3, title: 'Office Mail Sorting & Folder Categorization', category: 'Job Skill', status: 'Completed', score: 90 },
    { id: 4, title: 'Personal Hygiene & Work Attire Checklist', category: 'Self Care', status: 'In Progress', score: 85 },
  ]);

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-indigo-500/20 text-indigo-300 text-xs font-bold rounded-full border border-indigo-500/30">
            <Briefcase className="w-3.5 h-3.5" /> Module 20: Vocational Training & Independent Living Skills
          </div>
          <h2 className="text-2xl font-black mt-2">Adult Disability Employment & Life Skills Assessment</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-indigo-400">87.5% Work Readiness</div>
          <div className="text-xs text-slate-400">Independent Living Index</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tasks.map((task) => (
          <div key={task.id} className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-bold px-2 py-0.5 bg-indigo-500/20 text-indigo-300 rounded uppercase">
                {task.category}
              </span>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${task.status === 'Completed' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-amber-500/20 text-amber-300'}`}>
                {task.status}
              </span>
            </div>

            <div>
              <h3 className="text-sm font-bold text-slate-200">{task.title}</h3>
              <div className="flex items-center justify-between text-xs text-slate-400 mt-2">
                <span>Employer Scorecard:</span>
                <span className="font-mono font-bold text-emerald-400 text-sm">{task.score}%</span>
              </div>
            </div>

            <div className="w-full bg-slate-900 h-2 rounded-full overflow-hidden">
              <div className="bg-gradient-to-r from-blue-500 to-indigo-500 h-full rounded-full" style={{ width: `${task.score}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
